import { $hyc } from "@/utils/https";
const prefix = "/api/hyc/manage/finance";
const recordPath = (type, id) => `${prefix}/records/${type}/${id}`;
export const unwrapFinance = (response) => response?.data?.data ?? response?.data ?? response;
export const getFinanceOverview = () => $hyc().get(`${prefix}/overview`);
export const getFinanceRecords = (type, id) => $hyc().get(recordPath(type, id));
export const saveFinanceAttempt = (type, id, data) => $hyc().post(`${recordPath(type, id)}/attempts`, data);
export const saveFinanceReview = (type, id, data) => $hyc().post(`${recordPath(type, id)}/reviews`, data);
export const uploadFinanceAttachment = (type, id, file) => {
    const form = new FormData(); form.append("file", file);
    return $hyc().post(`${recordPath(type, id)}/attachments`, form);
};
export const accessFinanceAttachment = (type, id, attachmentId) => $hyc().get(`${recordPath(type, id)}/attachments/${attachmentId}/access`);
export const getFinanceExceptions = (params) => $hyc().get(`${prefix}/exceptions`, { params });
export const exportFinanceExceptions = (params) => $hyc().get(`${prefix}/exceptions/export`, { params });
export const retryFinancePromotionEvent = (id) => $hyc().post(`${prefix}/promotion-events/${id}/retry`, {});
